import {SET_PLAYER_CONTENT_DATA } from '../actions/playerContentData';

const initialState = {
    content_id: '',
    content_name: '',
    content_type : '',
    content_category: '',
    content_episode: '',
    content_list: ''
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_PLAYER_CONTENT_DATA:
      return { ...action.contentData};
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/playerContentData.js